import React from 'react';

import styles from './Prompt.module.css';

interface Props {
  isFirstArea: boolean;
  loadingComplete: boolean;
}

export function Prompt(props: Props) {
  const {
    loadingComplete,
    isFirstArea,
  } = props;

  if (!isFirstArea) return null;

  const text = loadingComplete ? 'click anywhere to begin' : 'loading...';

  return (
    <div className={styles['prompt']}>{text}</div>
  );
}
